var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modoul" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setting.title,
            visible: _vm.setting.visible,
            width: "600",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.setting, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formModal",
                  attrs: {
                    model: _vm.formModal,
                    rules: _vm.rules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "轮播图名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入轮播图名称" },
                        model: {
                          value: _vm.formModal.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "name", $$v)
                          },
                          expression: "formModal.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "取值键", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入取值键" },
                        model: {
                          value: _vm.formModal.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "code", $$v)
                          },
                          expression: "formModal.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "广告展示方式", prop: "display" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择广告展示方式" },
                          model: {
                            value: _vm.formModal.display,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "display", $$v)
                            },
                            expression: "formModal.display",
                          },
                        },
                        _vm._l(_vm.displayType, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "广告类别", prop: "type" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0 },
                          model: {
                            value: _vm.formModal.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "type", $$v)
                            },
                            expression: "formModal.type",
                          },
                        },
                        [_vm._v("图片")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.formModal.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "type", $$v)
                            },
                            expression: "formModal.type",
                          },
                        },
                        [_vm._v("文字")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setting.visible = false
                      _vm.$refs.formModal.resetFields()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.settingEvent } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }